import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  // Menu unificado - removido "Contato" redundante com "Fale Conosco"
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/servicos', label: 'Serviços' },
    { path: '/sobre', label: 'Sobre' },
    { path: '/trabalhe-conosco', label: 'Carreiras' }
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 ${
          isScrolled 
            ? 'bg-white border-b border-[#E2E8F0]' 
            : 'bg-[#F7FAFC]'
        }`}
      >
        <div className="container-main">
          <div className="flex items-center justify-between h-16">
            {/* Logo - Otimizado com srcSet retina, sem fundo */}
            <Link to="/" className="flex items-center h-full">
              <img 
                src="/logo-elauria-navbar-80.png"
                srcSet="/logo-elauria-navbar-80.png 1x, /logo-elauria-navbar-160.png 2x"
                alt={companyInfo.name} 
                className="h-[34px] w-auto object-contain bg-transparent"
                style={{ background: 'none', boxShadow: 'none', border: 'none' }}
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden lg:flex items-center gap-5">
              <a
                href={`tel:${companyInfo.contact.phone.replace(/\s/g, '')}`}
                className="flex items-center gap-2 text-[#475569] hover:text-[#0F172A] transition-colors text-sm"
              >
                <Phone size={14} />
                <span className="font-medium">{companyInfo.contact.phone}</span>
              </a>
              <Link to="/contato" className="btn-primary">
                Fale Conosco
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden p-2 text-[#475569]"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu lg:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-menu-link ${isActive(link.path) ? 'text-[#3E6B2A]' : ''}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="mt-8 space-y-3">
            <Link to="/contato" className="btn-primary w-full">
              Fale Conosco
            </Link>
            <Link to="/trabalhe-conosco" className="btn-secondary w-full">
              Trabalhe Conosco
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
